var _linearGradient, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSapLogo = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 455,
    height: 225,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 0,
    y2: 225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0ae"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05a",
    offset: 1
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m455 0h-455v225h230",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m225 45v106l-39-106h-39l-33 88c-4-22-27-30-45-36-12-4-25-9-25-16 0-5 7-10 20-9 9 1 17 1 33 9l16-27c-15-8-35-12-51-12-19 0-35 6-45 16-7 7-10 16-11 26 0 14 5 24 16 32 9 6 20 10 30 13 13 4 23 8 23 15-1 9-11 11-18 11-12 1-22-1-37-10l-14 27c15 9 31 13 50 13 13 0 33-4 44-14l-2 9h38l7-17c15 4 32 5 47 0l5 17h68v-40h14c35 0 56-17 56-47 0-34-20-48-63-48zm-73 88 14-45h1l14 45c-10 3-20 3-29 0zm111-23v-36h10c13 0 23 4 23 17 0 14-10 19-23 19z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSapLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sap-logo.3aa82cbc29939eaf628a6db81a1aa90b.svg";